import { useEffect, useState } from "react";
import Image from "next/image";
import { useTranslation } from "@/app/i18n/client";
import { CircularDiv } from "@/common/divs";

import { SemiBoldText } from "@/common/texts";
import { TagRef, TagType } from "@/types/components";
import {
  NEUTRO_PARAGRAPHS_COLOR,
  NEUTRO_TITLES_COLOR,
  PRIMARY_BUTTON_COLOR,
  SECONDARY_BUTTON_COLOR,
  WHITE_BUTTON_BORDER_COLOR,
} from "@/utils/constants";
import { renderMobilityTagIcon } from "@/utils/functions";

interface MobilityContainerProps {
  tag: TagType;
  tags: TagRef;
  parseTerm: (term: string) => void;
  deleteAll: boolean;
}

const MobilityContainer: React.FC<MobilityContainerProps> = ({
  tag,
  tags,
  parseTerm,
  deleteAll,
}) => {
  const [imSelected, setImSelected] = useState<boolean>(tag.selected);
  useEffect(() => {
    if (deleteAll) {
      setImSelected(false);
    }
  }, [deleteAll]);
  const handleSelectTag = () => {
    setImSelected(!imSelected);
    const foundTag = tags.current.find(
      (tagToFind: MobilityContainerProps["tag"]) => tagToFind.id === tag.id,
    );
    if (foundTag) {
      foundTag.selected = !foundTag.selected;
    }
    parseTerm(`mob:${tag.id}`);
  };

  const { t } = useTranslation();

  return (
    <CircularDiv
      background={imSelected ? PRIMARY_BUTTON_COLOR : SECONDARY_BUTTON_COLOR}
      height="32px"
      paddingX="16px"
      onClick={() => {
        handleSelectTag();
      }}
      style={{
        cursor: "pointer",
        border: "1px solid " + WHITE_BUTTON_BORDER_COLOR,
      }}
      width="fit-content"
    >
      <Image
        style={{
          marginBottom: "1px",
          marginRight: "2px",
          marginLeft: "-2px",
          width: "24px",
          height: "24px",
        }}
        src={renderMobilityTagIcon(tag.id)}
        alt={t(tag.i18_name)}
        width={24}
        height={24}
      ></Image>
      <SemiBoldText
        fontSize="14px"
        color={imSelected ? NEUTRO_TITLES_COLOR : NEUTRO_PARAGRAPHS_COLOR}
        style={{ marginTop: "-4px" }}
      >
        {t(tag.i18_name)}
      </SemiBoldText>
    </CircularDiv>
  );
};

export default MobilityContainer;
